/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1CourseregistrationDocumentStatusMutationRequest,
  PostApiV1CourseregistrationDocumentStatusMutationResponse,
  PostApiV1CourseregistrationDocumentStatus400,
  PostApiV1CourseregistrationDocumentStatus401,
  PostApiV1CourseregistrationDocumentStatus500,
} from "../../types/courseRegistrationDocumentController/PostApiV1CourseregistrationDocumentStatus.ts";

function getPostApiV1CourseregistrationDocumentStatusUrl() {
  const res = {
    method: "POST",
    url: `/api/v1/courseregistration/document/status` as const,
  };
  return res;
}

/**
 * @description Altera o status de um documento de matrícula para aprovado, aprovado provisório, pendente ou rejeitado, com opção de incluir motivo de rejeição. Retorna o novo status geral da documentação do curso e informações sobre status. **(Requer Authorization para autenticação)**
 * @summary Altera o status de um documento de matrícula (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/document/status}
 */
export async function postApiV1CourseregistrationDocumentStatus(
  data?: PostApiV1CourseregistrationDocumentStatusMutationRequest,
  config: Partial<
    RequestConfig<PostApiV1CourseregistrationDocumentStatusMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiV1CourseregistrationDocumentStatusMutationResponse,
    ResponseErrorConfig<
      | PostApiV1CourseregistrationDocumentStatus400
      | PostApiV1CourseregistrationDocumentStatus401
      | PostApiV1CourseregistrationDocumentStatus500
    >,
    PostApiV1CourseregistrationDocumentStatusMutationRequest
  >({
    method: "POST",
    url: getPostApiV1CourseregistrationDocumentStatusUrl().url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
